import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable, pipe } from 'rxjs';
import { ParamsType } from '@app/constants';
import { pagerAnimation } from '@app/animations';

@Component({
  selector: 'app-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,    
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.less'],
  animations: [pagerAnimation]
})
export class GridComponent  {

	@Input() articles$!: Observable<any[]>;
  @Input() displayPage!: boolean;
  @Input() queryParams$!: Observable<ParamsType>;
  @Input() orphan: boolean = false;

  public trackByMethod = (index:number, el:any): number => el.id * 1;
  
}
